"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _raf = _interopRequireDefault(require("raf"));

var _util = require("./util.js");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

var ScrollingMonitor =
/*#__PURE__*/
function () {
  function ScrollingMonitor(dragDropManager, container, options) {
    var _this = this;

    _classCallCheck(this, ScrollingMonitor);

    _defineProperty(this, "handleEvent", function (evt) {
      if (_this.dragging && !_this.attached) {
        _this.attach();

        _this.updateScrolling(evt);
      }
    });

    _defineProperty(this, "updateScrolling", (0, _lodash["default"])(function (evt) {
      var _this$container$getBo = _this.container.getBoundingClientRect(),
          x = _this$container$getBo.left,
          y = _this$container$getBo.top,
          w = _this$container$getBo.width,
          h = _this$container$getBo.height;

      var box = {
        x: x,
        y: y,
        w: w,
        h: h
      };
      var coords = (0, _util.getCoords)(evt); // calculate strength

      _this.scaleX = _this.options.horizontalStrength(box, coords);
      _this.scaleY = _this.options.verticalStrength(box, coords); // start scrolling if we need to

      if (!_this.frame && (_this.scaleX || _this.scaleY)) {
        _this.startScrolling();
      }
    }, 100, {
      trailing: false
    }));

    this.dragDropManager = dragDropManager;
    this.container = container;
    this.options = options;
    this.scaleX = 0;
    this.scaleY = 0;
    this.frame = null;
    this.attached = false;
    this.dragging = false;
  }

  _createClass(ScrollingMonitor, [{
    key: "start",
    value: function start() {
      var _this2 = this;

      this.container.addEventListener('dragover', this.handleEvent); // touchmove events don't seem to work across siblings, so we unfortunately
      // have to attach the listeners to the body

      window.document.body.addEventListener('touchmove', this.handleEvent);
      this.clearMonitorSubscription = this.dragDropManager.getMonitor().subscribeToStateChange(function () {
        return _this2.handleMonitorChange();
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      this.container.removeEventListener('dragover', this.handleEvent);
      window.document.body.removeEventListener('touchmove', this.handleEvent);
      this.clearMonitorSubscription();
      this.stopScrolling();
    }
  }, {
    key: "handleMonitorChange",
    value: function handleMonitorChange() {
      var isDragging = this.dragDropManager.getMonitor().isDragging();

      if (!this.dragging && isDragging) {
        this.dragging = true;
      } else if (this.dragging && !isDragging) {
        this.dragging = false;
        this.stopScrolling();
      }
    }
  }, {
    key: "attach",
    value: function attach() {
      this.attached = true;
      window.document.body.addEventListener('dragover', this.updateScrolling);
      window.document.body.addEventListener('touchmove', this.updateScrolling);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.attached = false;
      window.document.body.removeEventListener('dragover', this.updateScrolling);
      window.document.body.removeEventListener('touchmove', this.updateScrolling);
    } // Update scaleX and scaleY every 100ms or so
    // and start scrolling if necessary

  }, {
    key: "startScrolling",
    value: function startScrolling() {
      var _this3 = this;

      var i = 0;

      var tick = function tick() {
        var scaleX = _this3.scaleX,
            scaleY = _this3.scaleY,
            container = _this3.container;
        var _this3$options = _this3.options,
            strengthMultiplier = _this3$options.strengthMultiplier,
            onScrollChange = _this3$options.onScrollChange; // stop scrolling if there's nothing to do

        if (strengthMultiplier === 0 || scaleX + scaleY === 0) {
          _this3.stopScrolling();

          return;
        } // there's a bug in safari where it seems like we can't get
        // mousemove events from a container that also emits a scroll
        // event that same frame. So we double the strengthMultiplier and only adjust
        // the scroll position at 30fps


        if (i++ % 2) {
          var scrollLeft = container.scrollLeft,
              scrollTop = container.scrollTop,
              scrollWidth = container.scrollWidth,
              scrollHeight = container.scrollHeight,
              clientWidth = container.clientWidth,
              clientHeight = container.clientHeight;
          var newLeft = scaleX ? container.scrollLeft = (0, _util.intBetween)(0, scrollWidth - clientWidth, scrollLeft + scaleX * strengthMultiplier) : scrollLeft;
          var newTop = scaleY ? container.scrollTop = (0, _util.intBetween)(0, scrollHeight - clientHeight, scrollTop + scaleY * strengthMultiplier) : scrollTop;
          onScrollChange(newLeft, newTop);
        }

        _this3.frame = (0, _raf["default"])(tick);
      };

      tick();
    }
  }, {
    key: "stopScrolling",
    value: function stopScrolling() {
      this.detach();
      this.scaleX = 0;
      this.scaleY = 0;

      if (this.frame) {
        _raf["default"].cancel(this.frame);

        this.frame = null;
      }
    }
  }]);

  return ScrollingMonitor;
}();

exports["default"] = ScrollingMonitor;